import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { MapPin } from 'lucide-react'
import { toast } from 'react-toastify'
import {
  canUseGeolocation, getGpsConsent, setGpsConsent, readPosition, sendHeartbeat, OPEN_CONSENT_EVENT,
} from '../utils/visitorTracking'

const SHOW_DELAY_MS = 4000

// Asked once per browser: the answer is remembered and the card never comes back.
const GeoConsent = () => {
  const location = useLocation()
  const [visible, setVisible] = useState(false)
  const [busy, setBusy] = useState(false)
  const publicPage = !location.pathname.startsWith('/admin') && !location.pathname.startsWith('/login')

  useEffect(() => {
    if (!publicPage || getGpsConsent() !== null || !canUseGeolocation()) return undefined
    const timer = setTimeout(() => setVisible(true), SHOW_DELAY_MS)
    return () => clearTimeout(timer)
  }, [publicPage])

  useEffect(() => {
    const open = () => {
      if (canUseGeolocation()) {
        setVisible(true)
      } else {
        toast.info('La position précise ne peut être demandée que sur une connexion sécurisée (https).')
      }
    }
    window.addEventListener(OPEN_CONSENT_EVENT, open)
    return () => window.removeEventListener(OPEN_CONSENT_EVENT, open)
  }, [])

  if (!visible || !publicPage) return null

  const decline = () => {
    setGpsConsent('denied')
    setVisible(false)
    sendHeartbeat({ gpsConsent: 'denied' })
  }

  const accept = async () => {
    setBusy(true)
    try {
      const gps = await readPosition()
      setGpsConsent('granted')
      await sendHeartbeat({ gpsConsent: 'granted', gps })
    } catch (_err) {
      // refused in the browser prompt (or unavailable): remember it as a refusal
      setGpsConsent('denied')
      sendHeartbeat({ gpsConsent: 'denied' })
    }
    setBusy(false)
    setVisible(false)
  }

  return (
    <div className="geoConsent" role="dialog" aria-labelledby="geoConsent-title" aria-describedby="geoConsent-text">
      <div className="geoConsent__icon"><MapPin size={18} /></div>
      <div className="geoConsent__body">
        <p id="geoConsent-title" className="geoConsent__title">Partager votre position ?</p>
        <p id="geoConsent-text" className="geoConsent__text">
          Facultatif. Votre position aide l’équipe ALCM à savoir où les cantiques sont chantés.
          Elle n’est demandée qu’une seule fois ; vous pourrez changer d’avis depuis la mention « Confidentialité ».
        </p>
        <div className="geoConsent__actions">
          <button type="button" className="geoConsent__btn geoConsent__btn--primary" onClick={accept} disabled={busy}>
            {busy ? 'Localisation…' : 'Autoriser'}
          </button>
          <button type="button" className="geoConsent__btn" onClick={decline} disabled={busy}>
            Non merci
          </button>
        </div>
      </div>
    </div>
  )
}

export default GeoConsent
